export default function IconEducation() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-05b3195d-487e-48c9-aeb0-b294b135ddfa"
      data-name="Layer 2"
      viewBox="0 0 35.162 28.087"
    >
      <defs>
        <style>
          {
            ".uuid-5db4f818-96e0-4cb7-96e5-ce40f5d889b0{fill:none;stroke:var(--color-primary);stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"
          }
        </style>
      </defs>
      <g id="uuid-ec88a430-88f9-4f84-8505-7825c26e9565" data-name="Layer 1">
        <g id="uuid-4f3b025b-1a62-4e41-a70e-dece6a1bf333" data-name="g2036">
          <g id="uuid-d7694dd2-c5a5-4a6e-81b3-43735cb5f6ab" data-name="g2038">
            <g id="uuid-c676ed04-6c36-429b-8d75-013e4a98a44d" data-name="g2044">
              <path
                id="uuid-e62040ed-41b7-4df9-bfa8-c985f6a4226e"
                d="m34.162 9.088-16.58 8.089L1 9.089 17.581 1l16.581 8.088Z"
                className="uuid-5db4f818-96e0-4cb7-96e5-ce40f5d889b0"
                data-name="path2046"
              />
            </g>
          </g>
        </g>
        <g id="uuid-231debfa-81bd-4140-bbf0-df2d8bb5402d" data-name="g2048">
          <path
            id="uuid-fddc3532-6899-4048-a0ce-35be8a6e8d45"
            d="M28.829 11.69v10.402l-11.247 4.995-11.247-4.995V11.69"
            className="uuid-5db4f818-96e0-4cb7-96e5-ce40f5d889b0"
            data-name="path2050"
          />
        </g>
        <g id="uuid-dd312925-cab5-4307-827b-029e6d902610" data-name="g2052">
          <g id="uuid-001f6d36-6b80-424d-81d9-fcf8af49cfa6" data-name="g2054">
            <g id="uuid-55d62b76-49c6-4325-ad78-f19149c7c87c" data-name="g2060">
              <path
                id="uuid-d1b10fbf-1baf-4190-adde-f5af0b6d9191"
                d="M33.313 9.503v10.063"
                className="uuid-5db4f818-96e0-4cb7-96e5-ce40f5d889b0"
                data-name="path2062"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
